import logo from "assets/img/logo/logo_aig_login-2.png";
import Page from "components/Page";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React from "react";
import LoadingScreen from "react-loading-screen";
import { connect } from "react-redux";
import { Select } from "react-inputs-validation";
import { withRouter } from "react-router-dom";
import {
  Button, Card, CardBody, CardHeader, Col, Row,

  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
} from "reactstrap";
import "../../styles/estilos.css";
import "./styles.scss";

class ListaCompras extends React.Component {
  constructor(props) {
    super(props);
    const { datosCompras } = this.props;
    this.state = {
      activePage: 1,
      cotizacionesOri: datosCompras.datosCompras,
      datosCompras: datosCompras.datosCompras,
      numeroElementos: datosCompras.datosCompras.length,
      filtro: "",
      filtroselect: datosCompras.datosFiltro,
      filtroValor: "",
    };
  }

  handlePageChange = (pageNumber) => {

    this.setState({ activePage: pageNumber });
  };

  async componentDidMount() {
    this.state.datosCompras = this.state.datosCompras.map(item =>
      item.polDescripcionSeguro === "PITS"
        ? { ...item, polDescripcionSeguro: "PractiAuto" }
        : item
    );
  }

  /**
   * Filtra información de la tabla de a cuerdo a los filtros realizados por el usuario
   */
  handleAplicarFiltro = () => {
    let { filtro, cotizacionesOri, filtroValor } = this.state;
    filtro = filtro.toUpperCase();

    const cotizaciones = cotizacionesOri.filter(
      ({ polPlacas, polIdentificacionesAsegurados, polDescripcionRamo,
         fechaCreacion, nombreContratante, numeroCompra, 
         traMetodoPago,forpago, refInterna, traEstadoPlacetoPay,numeroitems, estadoFirma, estadoInspeccion, total }) => {
        if (!polPlacas) polPlacas = "";
        if (!polIdentificacionesAsegurados) polIdentificacionesAsegurados = "";

        if (!fechaCreacion) fechaCreacion = "";
        if (!nombreContratante) nombreContratante = "";
        if (!numeroCompra) numeroCompra = "";
 
        if (!forpago) forpago = "";
        if (!refInterna) refInterna = "";
        if (!traEstadoPlacetoPay) traEstadoPlacetoPay = "";
        if (!estadoFirma) estadoFirma = "";
        if (!estadoInspeccion) estadoInspeccion = "";
        if (!total) total = "";
        return (
          (polPlacas.indexOf(filtro) > -1 ||

          fechaCreacion.toString().indexOf(filtro) > -1 ||
          nombreContratante.indexOf(filtro) > -1 ||
          numeroCompra.toString().indexOf(filtro) > -1 ||
          //numeroitems.toString().indexOf(filtro) > -1 ||
          forpago.toString().toUpperCase().indexOf(filtro) > -1 ||
          refInterna.toString().indexOf(filtro) > -1 ||
          traEstadoPlacetoPay.indexOf(filtro) > -1 ||
          estadoFirma.indexOf(filtro) > -1 ||
          estadoInspeccion.indexOf(filtro) > -1 ||
          total.toString().indexOf(filtro) > -1 ||
          polIdentificacionesAsegurados.indexOf(filtro) > -1) &&
          polDescripcionRamo.indexOf(filtroValor) > -1
        );
      }
    );
    this.setState({ datosCompras: cotizaciones });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.datosCompras !== prevProps.datosCompras) {
      this.setState({
        cotizacionesOri: this.props.datosCompras.datosCompras,
        datosCompras: this.props.datosCompras.datosCompras.map(item =>
          item.polDescripcionSeguro === "PITS"
            ? { ...item, polDescripcionSeguro: "PractiAuto" }
            : item
        ),
        numeroElementos: this.props.datosCompras.datosCompras.length,
        filtroselect: this.props.datosCompras.datosFiltro,
      });
    }
    if (prevState.filtroValor !== this.state.filtroValor) {
      this.handleAplicarFiltro();
    }
  }

  textosCargando() {
    if (
      this.props.datosUsuario.usu_tipo_usuario !== undefined &&
      this.props.datosUsuario.usu_tipo_usuario !== "cliente" &&
      this.props.datosUsuario.usu_tipo_usuario !== "aglutinador-user"
    ) {
      return "Cargando Lista de Ventas...";
    }

    if (
      this.props.datosUsuario.usu_tipo_usuario !== undefined &&
      this.props.datosUsuario.usu_tipo_usuario === "cliente" &&
      this.props.datosUsuario.usu_tipo_usuario !== "aglutinador-user"
    ) {
      return "Cargando Lista de Compras...";
    }
  }

  onClick = async (id, event, forpago) => {

    event.preventDefault();
    if (forpago !== "NI") {
      this.props.history.push({
        pathname: "/final-cotizacion-detalle",
        search: `?id=${id}&estado=APROBADO&resumen=1`, //agregar parametros de la url,
      });
    } else {
      this.props.history.push({
        pathname: "/forma-pago",
        search: `?id=${id}`, //agregar parametros de la url,
      });
    }
  };

  bodyVerDetalles = (textoBoton) => (compras) => {

    /**
    *  Ir a la pantralla de recompra
    */
    const onClickRecompra = async () => {
      console.clear();
      this.props.history.push({
        pathname: "/recompra",
        search: `?id=${compras.idPoliza}`,
      });
    }

    return (
      <div>
        <Button
          className={"btn btn-primary"}
          onClick={(e) => this.onClick(compras.url, e, compras.forpago)}
          style={{ display: "block", margin: "auto" }}
        >
          <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
          {compras.forpago && compras.forpago === "NI"
            ? "COMPLETAR FORMA PAGO"
            : textoBoton}
        </Button>
        {compras.polDescripcionSeguro == 'KilometroPaquete' && (this.props.datosUsuario.usu_tipo_usuario == 'canal-user' ||this.props.datosUsuario.usu_tipo_usuario == 'broker-user' || this.props.datosUsuario.usu_tipo_usuario == 'asesor-user') && compras.numeroPolizaEmision!="" && compras.tieneRecompra == false && <Button
          style={{ display: "block", margin: "auto" }}
          className="btn btn-primaryy mt-2" onClick={onClickRecompra}>
          <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
          Recompra
        </Button>}

      </div>

    );
  };

  render() {

 
    const { activePage, numeroElementos } = this.state;

    const fin = activePage * 10;
    const inicio = fin - 10;
 

    let textoBoton = "DETALLES COMPRA";
    if (
      this.props.datosUsuario.usu_tipo_usuario &&
      this.props.datosUsuario.usu_tipo_usuario !== "cliente"
    ) {
      textoBoton = "DETALLES VENTA";
    }

    const {
      filtroselect,
      filtroValor,
    } = this.state;

    return (
      <LoadingScreen
        loading={this.props.datosCompras.isLoadingCompras}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={this.textosCargando()}
      >
        <Page
          title={
            this.props.datosUsuario.usu_tipo_usuario &&
              this.props.datosUsuario.usu_tipo_usuario !== "cliente"
              ? "Listado de Ventas"
              : "Listado de Compras"
          }
          breadcrumbs={[
            {
              name:
                this.props.datosUsuario.usu_tipo_usuario &&
                  this.props.datosUsuario.usu_tipo_usuario !== "cliente"
                  ? "Listado de Ventas"
                  : "Listado de Compras",
              active: true,
            },
          ]}
        >
          <Row>
          <Col lg={8} md={12} sm={12} xs={12}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      maxWidth: 1000,
                      marginBottom: 10,
                    }}
                  >
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          Placa o Identificación:
                        </InputGroupText>
                      </InputGroupAddon>

                      <Input
                        onChange={(e) => {
                          let val = e.target.value;
                          if (val)
                            this.setState({ filtro: e.target.value });
                          else
                            this.setState({
                              filtro: e.target.value,
                              cotizaciones: this.state.cotizacionesOri,
                            });
                        }}
                        value={this.state.filtro}
                        style={{ minWidth: 200 }}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") {
                            this.handleAplicarFiltro();
                          }
                        }}
                      />
                    </InputGroup>

                    <Button
                      className={"btn btn-primary"}
                      onClick={() => this.handleAplicarFiltro()}
                      style={{ display: "block", margin: "auto" }}
                    >
                      <i
                        className="fa fa-chevron-circle-right"
                        aria-hidden="true"
                      />{" "}
                      {"BUSCAR"}
                    </Button>
                    <br />
                  </div>
                </Col>
                <Col lg={4} md={12} sm={12} xs={12}>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>Ramo</InputGroupText>
                    </InputGroupAddon>
                    <div style={{ width: "270px" }}>
                      <Select
                        tabIndex="1" // Optional.[String or Number].Default: none.
                        id={"SelectRamo"} // Optional.[String].Default: "". Input ID.
                        name={"SelectRamo"} // Optional.[String].Default: "". Input name.
                        value={filtroValor} // Optional.[String].Default: "".
                        optionList={filtroselect} // Required.[Array of Object(s)].Default: [].
                        onChange={(selec, e) => {
                          this.setState({ filtroValor: selec });
                        }}
                        // Optional.[Func].Default: () => {}. Will return the value.
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationOption={{
                          name: "SelectRamo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: false, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "",
                        }}
                      />
                    </div>
                  </InputGroup>
                </Col>
               
          </Row>
          {this.state.datosCompras.length > 0 && (
            <div>
              <Row>
              
                <Col>
                  <Card body>
                    <DataTable
                      value={this.state.datosCompras}
                      responsive
                      className="p-datatable-customers"
                      rowHover
                      paginator
                      rows={10}
                      rowsPerPageOptions={[10, 25, 50]}
                      emptyMessage="No se han encontrado resultados"
                      resizableColumns
                    //currentPageReportTemplate="Visualizando {first} hasta {last} de {totalRecords} registros"
                    //paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                    >
                      <Column
                        className="counter"
                        field="contador"
                        header="#"
                        style={{ width: "60px" }}
                      />
                      <Column
                        field="fechaCreacion"
                        header="Fecha"
                        sortable
                        style={{ width: "100px" }}
                      />
                      <Column
                        header="Contratante"
                        field="nombreContratante"
                        sortable
                        style={{ width: "150px" }}
                      />
                      <Column
                        header="Nro. de identificación"
                        field="polIdentificacionesAsegurados"
                        sortable
                        style={{ width: "150px" }}
                      />
                      <Column
                        header="Ramo"
                        field="polDescripcionRamo"
                        sortable
                        style={{ width: "100px" }}
                      />
                       <Column
                        header="Producto"
                        field="polDescripcionSeguro"
                        sortable
                        style={{ width: "100px" }}
                      />
                      <Column
                        header="Número Póliza"
                        field="numeroPolizaEmision"
                        sortable
                        style={{ width: "100px" }}
                      />
                      <Column
                        header="Número Compra"
                        field="numeroCompra"
                        sortable
                        style={{ width: "100px" }}
                      />
                     {/*  <Column
                        header="# Items Asegurados"
                        field="numeroitems"
                        sortable
                        style={{ width: "110px" }}
                      /> */}
                      <Column
                        header="Forma de Pago"
                        field="traMetodoPago"
                        sortable
                        style={{ width: "150px" }}
                      />
                      {/* <Column
                        header="Referencia"
                        field="refInterna"
                        sortable
                        style={{ width: "150px" }}
                      /> */}
                      {/* <Column
                        header="Estado de Pago"
                        field="traEstadoPlacetoPay"
                        sortable
                        style={{ width: "100px" }}
                      /> */}
                      {/* <Column
                        header="Estado de Firma"
                        field="estadoFirma"
                        sortable
                        style={{ width: "90px" }}
                      /> */}
                     {/*  <Column
                        header="Estado de Inspección"
                        field="estadoInspeccion"
                        sortable
                        style={{ width: "100px" }}
                      /> */}
                      <Column
                        header="Valor"
                        body={(rowData) => `$${rowData.total}`}
                        sortable
                        style={{ width: "100px" }}
                      />
                      <Column
                        header="Detalles"
                        body={this.bodyVerDetalles(textoBoton)}
                        sortable
                        style={{ width: "220px" }}
                      />
                    </DataTable>
                  </Card>
                </Col>
              </Row>
            </div>

          )}

          {this.state.datosCompras.length === 0 && (
            <Row>
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="detalle-cotizacion-box"
              >
                <Card className="mb-3">
                  <CardHeader style={{ borderBottom: "none" }}></CardHeader>
                  <CardBody>
                    <h2 style={{ color: "#001871", textAlign: "center" }}>
                      {" "}
                      NO SE HA ENCONTRADO REGISTROS DE COMPRAS FINALIZADAS
                    </h2>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  datosCompras: state.dataCompras,
  datosUsuario: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ListaCompras)
);

/*


                  <Table
                    className="table-bordered"
                    style={{ textAlign: "center" }}
                    responsive
                  >
                    <thead>
                      <tr>
                        <th style={{ border: "1px solid #dee2e6" }}>#</th>
                        <th style={{ border: "1px solid #dee2e6" }}>Fecha</th>
                        <th style={{ border: "1px solid #dee2e6" }}>
                          Contratante
                        </th>
                        <th style={{ border: "1px solid #dee2e6" }}>
                          Número Compra
                        </th>
                        <th style={{ border: "1px solid #dee2e6" }}>
                          # Items Asegurados
                        </th>
                        <th style={{ border: "1px solid #dee2e6" }}>
                          Forma de Pago
                        </th>
                        <th style={{ border: "1px solid #dee2e6" }}>
                          Referencia
                        </th>
                        <th style={{ border: "1px solid #dee2e6" }}>
                          Estado de Pago
                        </th>
                        <th style={{ border: "1px solid #dee2e6" }}>
                          Estado de Firma
                        </th>
                        <th style={{ border: "1px solid #dee2e6" }}>
                          Estado de Inspección
                        </th>
                        <th style={{ border: "1px solid #dee2e6" }}>Valor</th>
                        <th style={{ border: "1px solid #dee2e6" }}>
                          Detalles
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {}
                      {datosCompras.datosCompras.map((compras, index) => {
                        if (index >= inicio && index < fin) {
                          return (
                            <tr key={`ListadoCompras${index}`}>
                              <td style={{ border: "1px solid #dee2e6" }}>
                                {compras.contador}
                              </td>
                              <td style={{ border: "1px solid #dee2e6" }}>
                                {compras.fechaCreacion}
                              </td>
                              <td style={{ border: "1px solid #dee2e6" }}>
                                {compras.nombreContratante}
                              </td>
                              <td style={{ border: "1px solid #dee2e6" }}>
                                {compras.numeroCompra}
                              </td>
                              <td style={{ border: "1px solid #dee2e6" }}>
                                {compras.numeroitems}
                              </td>
                              <td style={{ border: "1px solid #dee2e6" }}>
                                {compras.traMetodoPago}
                              </td>
                              <td style={{ border: "1px solid #dee2e6" }}>
                                {compras.refInterna}
                              </td>
                              <td style={{ border: "1px solid #dee2e6" }}>
                                {compras.traEstadoPlacetoPay}
                              </td>
                              <td style={{ border: "1px solid #dee2e6" }}>
                                {compras.estadoFirma}
                              </td>
                              <td style={{ border: "1px solid #dee2e6" }}>
                                {compras.estadoInspeccion}
                              </td>
                              <td style={{ border: "1px solid #dee2e6" }}>
                                ${compras.total}
                              </td>
                              <td style={{ border: "1px solid #dee2e6" }}>
                                <Button
                                  className={"btn btn-primary"}
                                  onClick={(e) =>
                                    this.onClick(
                                      compras.url,
                                      e,
                                      compras.forpago
                                    )
                                  }
                                  style={{ display: "block", margin: "auto" }}
                                >
                                  <i
                                    className="fa fa-chevron-circle-right"
                                    aria-hidden="true"
                                  />{" "}
                                  {compras.forpago && compras.forpago === "NI"
                                    ? "COMPLETAR FORMA PAGO"
                                    : textoBoton}
                                </Button>
                              </td>
                            </tr>
                          );
                        } else return null;
                      })}
                    </tbody>
                  </Table>



*/
